import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import { CloseIcon } from 'asterX-UI/Icons'
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { useResErrors } from 'hooks'
import { useSnackbar } from 'notistack'
import { TiresService } from 'lib/api/services/tires.service'
import { PageContainer } from 'components/PageContainer'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  btns: {
    display: 'flex',
    gap: 12,
    marginTop: 32,
    fontSize: 14
  }
}))
export const TiresModal = ({ onClose }) => {
  const classes = useStyles()
  const { silentCheck } = useResErrors()
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [tiresId, setTiresId] = useState(null)
  const [tires, setTires] = useState([])
  const {
    store: { sale, commentsRSE },
    funcs: { clearUpdateSale }
  } = useSelectionStore()

  const onSearch = async () => {
    setLoading(true)
    const data = {
      id: Number(tiresId),
      offset: 0,
      limit: 10
    }
    await TiresService.getTires(data).then(res =>
      silentCheck(res, ({ data }) => {
        setTires(data?.content)
        if (data?.content?.length === 0) {
          enqueueSnackbar('Шина не найдена', {
            variant: 'error'
          })
        }
      })
    )
    setLoading(false)
  }

  const handleSave = async () => {
    const data = {
      client: {
        firstName: sale?.client?.firstName,
        lastName: sale?.client?.lastName,
        middleName: sale?.client?.middleName,
        phoneNumber: sale?.client?.phoneNumber,
        language: sale?.client?.language,
        gender: commentsRSE?.gender
      },
      tiresId: tiresId
    }

    clearUpdateSale(data).then(res => onClose())
  }

  return (
    <PageContainer
      customHeader={
        <div className={classes.header}>
          <div className={classes.heading}>Шины</div>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <Grid item container alignItems="center" spacing={2}>
        <Grid item xs={8} md={8}>
          <TextField
            label={'ID комплекта'}
            fullWidth
            value={tiresId}
            onChange={e => setTiresId(e.target.value)}
          />
        </Grid>
        <Grid item xs={4} md={4}>
          <Button
            disabled={!tiresId}
            variant={'outlined'}
            color={'primary'}
            fullWidth
            size={'small'}
            onClick={onSearch}
          >
            {loading && (
              <CircularProgress
                style={{ position: 'absolute', left: 10 }}
                size={15}
              />
            )}
            Поиск
          </Button>
        </Grid>
        <Grid item container xs={12} md={12} justifyContent="center">
          {(tires || []).map(tire => (
            <Typography variant="subtitle1">
              {tire?.mark?.name} {tire?.model?.name} ({tire?.width}/
              {tire?.height}/R{tire?.radius})
            </Typography>
          ))}
        </Grid>
      </Grid>

      <div className={classes.btns}>
        <Button variant={'contained'} fullWidth size={'small'} onClick={''}>
          Отмена
        </Button>
        <Button
          disabled={!tires[0]?.id}
          variant={'contained'}
          color={'primary'}
          fullWidth
          size={'small'}
          onClick={handleSave}
        >
          Сохранить
        </Button>
      </div>
    </PageContainer>
  )
}
